import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

const WarningValidarCuenta = () => {
  const { t } = useTranslation()

  return (
    <div className='header__warning_message'>
      <FontAwesomeIcon
        icon={["fal", "triangle-exclamation"]}
        className='icon-size-md'
      />
      <span className='ml-2'>
        {t("perfilEmpresa.company.warningValidatedAccount.text")}{" "}
        {/* TODO: Magic string */}
        <Link to='/perfil/empresa'>
          {t("perfilEmpresa.company.warningValidatedAccount.textBold")}
        </Link>{" "}
      </span>
    </div>
  )
}

export default WarningValidarCuenta
